<div class="flex h-full min-h-0 w-full flex-col overflow-hidden">
  @if (isProfile()) {
    <div class="shrink-0 border-b border-zinc-200 px-4 py-3 dark:border-zinc-800">
      <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="backToList()">
        Back to list
      </button>
    </div>
  } @else {
    <admin-stats-section-nav [items]="navItems" />
  }
  <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
    <router-outlet />
  </div>
</div>
